import Page from '@inspire/ui/chakra/layout/Page';
import { OnlyForProf } from 'components/auth/Redirects';
import Layout from 'components/layout/Layout';
import FichesActivites from 'components/prof/FichesActivites';

const FichesActivitesPage = () => (
  <Page title="Fiches activités" withPanel headingIsTitle>
    <FichesActivites />
  </Page>
);

FichesActivitesPage.getWrappers = (page) => (
  <Layout variant="app" rowVariant="gray">
    <OnlyForProf>{page}</OnlyForProf>
  </Layout>
);

export default FichesActivitesPage;
